import React from 'react';
import { Chart } from '../../Enums/Chart.enum';
import useHealthData from '../../Hooks/useHealthData';
import { HealthDataFilterFormValues } from '../Filter/HealthDataFilterForm';
import HealthDataBaseChart from './HealthDataChartBase';
import { CHARTS_DATASET } from '../../Utils/chartsDataset';

interface HealthDataChartProps {
	patientId: string;
	filter: HealthDataFilterFormValues;
	chartType: Chart;
	healthData?: any;
	isLoading?: boolean;
}

const HealthDataChart: React.FC<HealthDataChartProps> = ({
	patientId,
	filter,
	healthData,
	chartType,
	isLoading,
}) => {
	const { filterKeys } = useHealthData();
	const { keys, ...otherFilters } = filter;

	return (
		<HealthDataBaseChart
			patientId={patientId}
			chartType={chartType}
			healthData={healthData}
			{...otherFilters}
			keys={filterKeys(keys, CHARTS_DATASET[chartType].keys)}
			chartTitle={CHARTS_DATASET[chartType].title}
			isLoading={isLoading}
		/>
	);
};

export default HealthDataChart;
